
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ShiftTypeInterface } from '@/services/Calendar/ShiftType/Interfaces';
import ShiftTypeRepository from '@/services/Calendar/ShiftType';

@Component({
  inject: [
    'shiftTypeRepository',
  ],
})
export default class DeleteShiftTypeDialog extends Vue {
  private readonly shiftTypeRepository!: ShiftTypeRepository;

  @Prop() private readonly shiftType!: ShiftTypeInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete '${this.shiftType.name}'?`;
  }

  private async deleteShiftType(): Promise<void> {
    try {
      await this.shiftTypeRepository.deleteShiftType(this.shiftType.id);
      this.$successDialog.show(`Shift Type '${this.shiftType.name}' has been deleted.`);
      this.$emit('deleted-shift-type', this.shiftType.id);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
